import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CustomLink } from '../../../../common/CustomLink'
import { Legend } from '../../../../common/chart/legend'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Notification } from '../../../../common/notification'
import { formatText } from '../../../../helpers/value'
import { COMPONENTS } from '../../../../routers/constants'
import { VALUE_SCORE } from '../../constant'
import { selectScoreActive } from '../../store/slice'
import { SelectSearch } from '../common/SelectSearch'
import { DATA_CHECKBOX, IDS_TREND_BY_PORT, TYPE_CHART_RISK } from '../constant'
import { convertDataCheckBox, handleGetIdsCheckDynamic } from '../helper'
import classes from '../index.module.scss'
import {
  getDataReduxTable,
  getDataReduxTablePer,
  selectActivePortfolio,
  selectDataChart,
  selectDataChartPer,
} from '../store/slice'
import { ChartScore } from './ChartScore'

export const Chart = ({
  isDynamicReport,
  portfolio1,
  portfolio2,
  checkTypePort,
  timePeriod,
  type,
  isJPG = false,
}) => {
  const { value: typeValueStore } = useSelector(selectScoreActive)
  const dataRisk = useSelector(selectDataChart)
  const dataPer = useSelector(selectDataChartPer)
  const activePortfolio2 = useSelector(
    selectActivePortfolio('activePortfolio2'),
  )
  const activePortfolio1 = useSelector(
    selectActivePortfolio('activePortfolio1'),
  )

  const typeValue = isDynamicReport ? type : typeValueStore
  const data = typeValue === VALUE_SCORE.CREDIT_SCORE ? dataRisk : dataPer

  const dataRowPortLargest = useSelector(
    typeValue === VALUE_SCORE.CREDIT_SCORE
      ? getDataReduxTable(IDS_TREND_BY_PORT.LARGEST)
      : getDataReduxTablePer(IDS_TREND_BY_PORT.LARGEST),
  )
  const dataRowPortLowest = useSelector(
    typeValue === VALUE_SCORE.CREDIT_SCORE
      ? getDataReduxTable(IDS_TREND_BY_PORT.LOWEST)
      : getDataReduxTablePer(IDS_TREND_BY_PORT.LOWEST),
  )

  const dataPortLargest = Object.values(dataRowPortLargest || {}).find(
    (item) => !!item?.portfolioId,
  )
  const dataPortLowest = Object.values(dataRowPortLowest || {}).find(
    (item) => !!item?.portfolioId,
  )

  const [isShowRange, setShowRange] = useState(isDynamicReport ? false : true)
  const [listCheckBox, setListCheckBox] = useState(
    isDynamicReport
      ? convertDataCheckBox(
          handleGetIdsCheckDynamic(portfolio1, portfolio2, checkTypePort),
        )
      : DATA_CHECKBOX,
  )

  const legendItems = [
    {
      title: 'portfolioScore.filteredPortfolio',
      color: TYPE_CHART_RISK[0].color,
      dataKey: 'data1',
      iconCustom: true,
      renderCustomIcon: () => {
        return (
          <Element
            style={{
              height: 5,
              width: 16,
              backgroundColor: TYPE_CHART_RISK[0].color,
              cursor: 'default',
            }}
          />
        )
      },
    },
    {
      title: (
        <div className="flexColumn">
          <Translate value="portfolioScore.portfolioDecline" />
          <CustomLink
            target="_blank"
            to={
              dataPortLargest?.portfolioId
                ? `${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${dataPortLargest?.portfolioId}`
                : ''
            }
            onClick={(e) => e.stopPropagation()}
          >
            <Element
              className="fstItalic"
              style={{
                color: dataPortLargest?.portfolioName ? '#2C73E8' : '',
              }}
            >
              ({formatText(dataPortLargest?.portfolioName)})
            </Element>
          </CustomLink>
        </div>
      ),
      color: TYPE_CHART_RISK[1].color,
      dataKey: 'data2',
      isCheckbox: true,
      isI18n: false,
      isDynamicReport: isDynamicReport || isJPG,
    },
    {
      title: (
        <div className="flexColumn">
          <Translate value="portfolioScore.portfolioLowest" />
          <CustomLink
            target="_blank"
            to={
              dataPortLowest?.portfolioId
                ? `${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${dataPortLowest?.portfolioId}`
                : ''
            }
            onClick={(e) => e.stopPropagation()}
          >
            <Element
              className="fstItalic"
              style={{
                color: dataPortLowest?.portfolioName ? '#2C73E8' : '',
              }}
            >
              ({formatText(dataPortLowest?.portfolioName)})
            </Element>
          </CustomLink>
        </div>
      ),
      color: TYPE_CHART_RISK[2].color,
      dataKey: 'data3',
      isCheckbox: true,
      isI18n: false,
      isDynamicReport: isDynamicReport || isJPG,
    },
    {
      title: (
        <>
          {isDynamicReport ? (
            <>{portfolio1?.namePortfolio}</>
          ) : (
            <SelectSearch
              activePortfolio={activePortfolio1}
              keyPort="activePortfolio1"
            />
          )}
        </>
      ),
      isI18n: false,
      isCheckOnClickText: false,
      translateProps: { description: data[0]?.description3 },
      color: TYPE_CHART_RISK[3].color,
      dataKey: 'data4',
      isCheckbox: true,
      isDynamicReport: isDynamicReport || isJPG,
    },
    {
      title: (
        <>
          {isDynamicReport ? (
            <>{portfolio2?.namePortfolio}</>
          ) : (
            <SelectSearch
              activePortfolio={activePortfolio2}
              keyPort="activePortfolio2"
            />
          )}
        </>
      ),
      isI18n: false,
      isCheckOnClickText: false,
      color: TYPE_CHART_RISK[4].color,
      dataKey: 'data5',
      isCheckbox: true,
      isDynamicReport: isDynamicReport || isJPG,
    },
  ]

  if (isDynamicReport && !data.length) {
    return <Notification isDynamicReport />
  }

  return (
    <>
      <div className={`dFlex justifyContentBetween ${classes.chart}`}>
        <div className="w75">
          {!isDynamicReport && !isJPG && (
            <Checkbox
              title="score.premium.SHOW_RANGE"
              isI18n
              checked={isShowRange}
              isCheckOnClickText
              style={{
                paddingLeft: 6,
              }}
              onChange={() => {
                setShowRange((prev) => !prev)
              }}
            />
          )}
          <ChartScore
            isShowRange={isShowRange}
            data={data}
            listCheckBox={listCheckBox}
            isDynamicReport={isDynamicReport}
            timePeriod={timePeriod}
            typeValue={typeValue}
          />
        </div>
        <div className="w25">
          <Legend
            items={legendItems}
            style={{ flexDirection: 'column', gap: 14 }}
            listCheckBox={listCheckBox}
            setListCheckBox={setListCheckBox}
          />
        </div>
      </div>

      <div
        id="trendByPortfolioId"
        style={{ position: 'fixed', top: -1000, left: -2000, width: 800 }}
      >
        <div className={`dFlex justifyContentBetween ${classes.chart}`}>
          <div className="w75">
            <ChartScore
              isShowRange={isShowRange}
              data={data}
              listCheckBox={listCheckBox}
              isDynamicReport={isDynamicReport}
              timePeriod={timePeriod}
            />
          </div>
          <div className="w25">
            <Legend
              items={legendItems.map((item) => ({
                ...item,
                isDynamicReport: true,
              }))}
              style={{ flexDirection: 'column', gap: 14 }}
              listCheckBox={listCheckBox}
              setListCheckBox={setListCheckBox}
            />
          </div>
        </div>
      </div>
    </>
  )
}

Chart.propTypes = {
  isDynamicReport: PropTypes.bool,
  portfolio1: PropTypes.object,
  portfolio2: PropTypes.object,
  checkTypePort: PropTypes.array,
  timePeriod: PropTypes.string,
}

Chart.defaultProps = {
  isDynamicReport: false,
  portfolio1: {},
  portfolio2: {},
  checkTypePort: [],
  timePeriod: 'Yearly',
}
